import React from 'react';

import Context from '../../../../context';

import { useTranslation } from 'react-i18next';

import { CustomModal, CustomButton2, ResponsiveView } from '../../../../components';

import './index.sass';

/**
 * Confirms carrying last year's drivers into the selected academic year — one driver when the row's own action was
 * used, or every ticked row when the bulk button was.
 */
const TransferAcademicYear: React.FC = (): React.ReactElement => {

  const { t } = useTranslation();

  const {
    showModal,
    setShowModal,
    isLoading,
    selectedDriver,
    selectedDriverIds,
    transferFunction,
  } = React.useContext(Context.DriverScreen);

  const isBulk: boolean = !selectedDriver && (selectedDriverIds?.length ?? 0) > 0;

  function submitHandler(): void {
    const driverIds = isBulk ? selectedDriverIds! : [selectedDriver?._id];
    transferFunction!(driverIds);
  }

  function handleCancel(): void {
    setShowModal!('NONE');
  }

  return (
    <section id="driver-transfer-academic-year-modal-container">
      <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "TRANSFER_ACADEMIC_YEAR"}>
        <ResponsiveView.Container className="create-form-content">
          <ResponsiveView.Row className="form-row">
            <p>
              {isBulk
                ? `آیا تأیید می‌کنید که ${selectedDriverIds?.length} راننده سال گذشته به سال تحصیلی جاری منتقل شوند؟`
                : `آیا تأیید می‌کنید که راننده «${selectedDriver?.firstName} ${selectedDriver?.lastName}» به سال تحصیلی جاری منتقل شود؟`}
            </p>
          </ResponsiveView.Row>
          <ResponsiveView.Row className="form-row">
            <ResponsiveView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2 isLoading={isLoading} onClick={handleCancel} title={t("cancel")} type={'danger'}/>
            </ResponsiveView.Column>
            <ResponsiveView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </section>
  );
};

export default TransferAcademicYear;
